import React, { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { TIconsNames } from "../../iconSets";
import Icon from "../Icon";
import "./style.scss";

interface ButtonProps {
  size?: "large" | "sm" | "xs" | "square";
  main?: boolean;
  color?: "green" | "blue" | "purple" | "red" | "black";
  block?: boolean;
  disabled?: boolean;
  type?: "button" | "submit";
  beforeIcon?: TIconsNames; // Update with the correct type for icons
  afterIcon?: TIconsNames; // Update with the correct type for icons
  beforeClass?: string;
  afterClass?: string;
  href?: string;
  to?: string; // Ensure this matches the expected type for `to` in Link
  loading?: boolean;
  target?: string;
  children?: ReactNode;
  before?: ReactNode;
  after?: ReactNode;
  onClick?: () => void;
  id?: string;
}

const Button: FC<ButtonProps> = ({
  size,
  main,
  color,
  block,
  disabled,
  type = "button",
  beforeIcon,
  afterIcon,
  beforeClass,
  afterClass,
  href,
  to,
  loading,
  target,
  children,
  before,
  after,
  onClick,
  id,
}) => {
  const rootComponent: any = href ? "a" : to ? Link : "button";

  const classNames = [
    "buttonG",
    main && "buttonG--main",
    block && "buttonG--block",
    size && `buttonG--${size}`,
    color && `buttonG--${color}`,
  ]
    .filter(Boolean)
    .join(" ");

  const buttonProps = {
    className: classNames,
    ...(disabled ? { disabled } : {}),
    ...(href ? { href, target } : {}),
    ...(to ? { to } : {}),
    ...(type ? { type } : {}),
    onClick,
    id,
  };

  return React.createElement(
    rootComponent,
    buttonProps,
    <>
      {!loading && (beforeIcon || before) && (
        <div className={`buttonG__before ${beforeClass || ""}`}>
          {before || (beforeIcon && <Icon icon={beforeIcon} size='20' />)}
        </div>
      )}
      {loading && (
        <div className='px-6'>
          <div className='spinner'></div>
        </div>
      )}
      {!loading && children}
      {!loading && (afterIcon || after) && (
        <div className={`buttonG__after ${afterClass || ""}`}>
          {after || (afterIcon && <Icon icon={afterIcon} size='20' />)}
        </div>
      )}
    </>,
  );
};

export default Button;
